import React, { Component } from 'react';
import { flow } from 'lodash';
import PropTypes from 'prop-types';
import { TimelineMax } from 'gsap';
import withSlide from '../Slide';

class FullImgSnap extends Component {
  constructor(props) {
    super(props);

    this.imgElements = [];
  }

  componentDidMount() {
    this.timeline = new TimelineMax();

    if (this.props.loop) {
      this.timeline.repeat(-1);
    }

    this.props.images.forEach((img, index) => {
      const duration = img.duration
        ? img.duration
        : this.props.duration / this.props.images.length;

      if (index === 0) {
        this.timeline.set(this.imgElements[index], { display: 'block' });
      }

      this.timeline.to(this.imgElements[index], duration, {
        display: 'block',
        scale: 1.05
      });

      if (this.props.loop || index + 1 < this.props.images.length) {
        this.timeline.set(this.imgElements[index], { clearProps: 'display' });
      }
    });

    this.timeline.pause();

    this.props.setGreensockObjectFunc(this.timeline);
  }

  setImgRef = imgElement => {
    // this callback is activated on unmount for some reason, so gotta make sure we're receiving a real element
    if (imgElement) {
      const index = imgElement.attributes.index.value;
      this.imgElements[index] = imgElement;
    }
  };

  render() {
    const imageClass = 'slide__content__animation-type--FullImgSnap__img';

    return (
      <div className={this.props.classNameFunc('FullImgSnap')}>
        {this.props.images.map((img, index) => {
          return (
            <img
              alt={img.imageAltText}
              className={imageClass}
              height="390"
              index={index}
              key={index}
              ref={this.setImgRef}
              src={img.src}
              width="940"
            />
          );
        })}
      </div>
    );
  }
}

FullImgSnap.defaultProps = {
  loop: true,
  imageAltText: ''
};

FullImgSnap.propTypes = {
  classNameFunc: PropTypes.func.isRequired,
  duration: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      imageAltText: PropTypes.string,
      duration: PropTypes.number,
      src: PropTypes.string.isRequired
    })
  ),
  loop: PropTypes.bool,
  paused: PropTypes.bool.isRequired
};

export default flow(withSlide)(FullImgSnap);



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/slideTypes/FullImgSnap.js